module.exports = __webpack_public_path__ + "static/img/PU_deskstop.c801fe28.jpg";